// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2GoBJ","title":"ClientInsurance_title__R5lmt","itemText":"ClientInsurance_itemText__1Mqxh"};